import React from 'react';
import { Image } from 'react-bootstrap';

import './Fragor.css';

const fragor = props => (
  <div className="column-container">
    <div className="fragor-image">
      <Image src="images/Ovrigt/lankar.jpg" responsive></Image>
    </div>

    <div className="fragor-info">
      <div className="compact">
        <h3>Vanliga frågor</h3>

        <h4>Hur många böcker finns det?</h4>
        <p>Det finns två böcker. Bok nr 1 ”Vännerna i Kungaskogen bygger en koja” (48 sid). Förlaget brukar kalla den Kojan. Bok nr 2 ”Vännerna i Kungaskogen går på utflykt” (86 sid). Förlaget brukar
          kalla den Utflykt. En tredje berättelse nr 3 ”Vännerna i Kungaskogen träffar nytt kompisgäng” har lagts ut i accessen och inspelningar pågår.</p>

        <h4>Hur många accesser finns det?</h4>
        <p>Det finns en access till Bok nr 1 Kojan och en till Bok nr 2 Utflykt.</p>

        <h4>Vad ingår i själva boken?</h4>
        <p>I boken ingår bildberättelse, QR koder med alla dialoger och musik (finns också på CD skivor), sångbok med noter, texter och ackordanalyser.</p>

        <h4>Kan man jobba med båda böckerna samtidigt?</h4>
        <p>Ja, men det är mycket material att gå igenom på en gång.</p>

        <h4>Vilken bok ska man börja med?</h4>
        <p>Börja alltid med ”Vännerna i Kungaskogen bygger en koja”.</p>

        <h4>Vad ingår i Temapaketen?</h4>
        <p>I Temapaketen ingår bok, QR koder dialoger och musik, (finns också på CD skivor som följer med), sångbok med noter, text och ackordanalyser. Handledning på Internet på ca 1000 sidor (1 år). Se mer på flik Access vad som finns i accessen.</p>


        <h4>Vilket material är bäst att komplettera Temapaketen med?</h4>
        <p>Vi rekommenderar Handdockor Kungaskogen för dramatisering av sagan. Kolla också
Barnens almanacka, memo och pussel. </p>

        <h4>Vilka kringprodukter finns till Kungaskogen?</h4>
        <p>Barnens almanackstavla Calendo, Memo Kungaskogen, Pussel Kungaskogen, Pärlplattor Kungaskogen, Handdockor Kungaskogen, mm</p>

        <h4>Kommer fler produkter till Kungaskogen och vad händer i år?</h4>
        <p>Ja. Förlaget jobbar hela tiden med utveckling av konceptet Vännerna i Kungaskogen. Vi jobbar på bok nr 3 ”Vännerna i Kungaskogen träffar ett nytt kompisgäng”, en ny sångbok med Kungaskogensångerna, ny musik, nya produkter kring Kungaskogen. Förlaget ställer också ut Kungaskogen på mässor. I höst visas hela Kungaskogen på Bokmässan i Göteborg. Fölaget jobbar också med att tillgängliggöra Kungaskogen mera genom andra förlag, återförsäljare, events, nya koncept andra aktörer och nya produkter.
</p>

  <h4>Vad är det enklast att se allt om Kungaskogen? På Instagram!</h4>
  <p>Just nu lägger vi ut info om Kungaskogen kontinuerligt på Instagram. Här finns allt uppdaterat och vad som är aktuellt från teater, nya produkter, händelser, mässor mm.</p>

  <h4>Var beställer man Kungaskogen?</h4>
  <p>Webbutiken finns på www.forskoleprodukter,se och här finns alla Kungaskogenprodukterna att beställa.
Du kan också skicka mejl till idea@ilka.se  eller ringa 040 120012.</p>

  <h4>Kan man komma med egna idéer om Kungaskogen?</h4>
  <p>Ja det är bara att ta kontakt med förlaget som tacksamt tar del av allt kring Kungaskogen.
Förlaget nås direkt på idea@ilka.se och vi svarar direkt.</p>



        <h4>Kan man bara köpa boken?</h4>
        <p>Ja, om man har gällande access. Om man inte har det så hänvisar vi till våra Temapaket. OBS Priset för lös bok är ett extrapris. ”Boken” består ju av bildberättelser, sångbok och musikproduktion
          på flera timmar. Ett sådan bok skulle kosta betydligt mera men vi håller priset lågt så att flera avdelningar kan ha en egen bok.</p>

        <h4>Kan man köpa boken privat?</h4>
        <p>Ja, om den ska användas enbart för privat bruk. Förlaget policy är att det är slutanvändaren som ska köpa in materialet. Inte t ex pedagog privat som sen använder boken som underlag i sin
        undervisning.</p>

        <h4>Varför kan man inte bara köpa boken när man vill börja med Kungaskogen?</h4>
        <p>Kungaskogen har blivit ett tematiskt material och därför vill förlaget att man tar del av hela materialet. Temapaketet ger också pedagogen en friare rätt att använda materialet och slippa tänka på
        upphovsrätten. I handledningen, Accessen, finns idag nästan allt man behöver för att uppfylla förskolans läroplan.</p>

        <h4>Vad händer om man bara beställer boken och inte har accessen?</h4>
        <p>Ordern kommer att passera igenom på hemsidan men förlagets administration kommer att göra om ordern till paketet med bok och handledning.</p>

        <h4>Är det olika accesser till de olika böckerna?</h4>
        <p>Ja, det är en access anpassad för Bok nr 1 ”Vännerna i Kungaskogen bygger en koja” och en access för Bok nr 2 ”Vännerna i Kungaskogen går på utflykt”.</p>

        <h4>Hur länge räcker accesserna?</h4>
        <p>Accessen (Handledning) räcker ett helt år. Efter 1 år så förlängs accessen för kampanjpris om inte kunden säger upp accessen.</p>

        <h4>Hur säger man upp accessen?</h4>
        <p>Det kan man göra under hela perioden senast 1 vecka innan utgången. Räcker att skriva ett enkelt mejl till idea@ilka.se</p>

        <h4>Spar accessen planeringstid?</h4>
        <p>Ja, accessen spar massor av planeringstid. Massor av teman och fakta finns i accessen och man slipper att kopiera fram egna material eller googla runt.</p>

        <h4>Finns det någon garanti?</h4>
        <p>Ja, det finns det. Vid förlängning av accesserna har man garanti på CD skivorna. Blir de t ex repiga så är det bara att skicka in dem till förlaget så får man nya. Garantin gäller de CD skivor som
          hör till den gällande accessen.</p>

        <h4>Hur många förskolor/förskoleklasser använder Kungaskogen?</h4>
        <p>Ca 9000 i Sverige.</p>

        <h4>Varför är Kungaskogen förskolans med använda värdegrundsmaterial?</h4>
        <p>Sagan och musiken går direkt in hos barnen. Sagan är skriven på 2000-talet för de barn som växer upp idag. Många andra sagor är skrivna för länge sedan och kanske inte alltid är anpassade för dagens barn. Materialet inbjuder till stor kreativitet hos både vuxna och barn. Det är lätt att föra budskap och värdegrunder vidare med sagan som utgångspunkt.</p>

        <h4>Vilka teman kan man jobba med när man använder Kungaskogen?</h4>
        <p>Värdegrunder, kompisar, empati, respekt, natur, djur, matte, språk, miljö och hållbarhet, teknik, drama, rörelser mm.</p>

        <h4>Kan man spela egen teater med Kungaskogen?</h4>
        <p>Ja, när man har gällande access. Det finns också teatermanus att tillgå om man vill.</p>

        <h4>Vilken bildteknik används i illustrationerna till Kungaskogen?</h4>
        <p>Bilderna är akvarell med karaktärer i heltäckande färger.</p>

        <h4>Hur är musikinspelningarna gjorda?</h4>
        <p>De flesta musikinspelningarna är akustiska dvs det är riktiga musiker som spelar olika instrument.</p>

        <h4>Finns Kungaskogen med rörliga bilder?</h4>
        <p>Ja, Kungaskogen finns som teater och som kan streamas t ex direkt på förskolan. Bioteater är en avfilmad teaterföreställning.</p>


        <h4>Kan man köpa Kungaskogen på andra ställen?</h4>
        <p>Nej. Kungaskogen säljs bara genom förlaget ILKA. Produkten är framtagen inom förlaget och på så sätt har kostnaderna kunnat hållas nere och inga fördyrande mellanhänder finns.</p>

        <h4>Finns Kungaskogen på Biblioteket så man kan låna den?</h4>
        <p>Förlaget säljer bara materialet till slutanvändare t ex förskolor/förskoleklasser, familjedaghem, privata hem och liknade.</p>

        <h4>Kan man använda Kungaskogen på föräldrarträffar och avslutningar?</h4>
        <p>Ja, det kan man. Om man vill spela egen teater så gäller gällande access. Sångerna kan alltid framföras. Kommunen har alltid avtal med rättighetsförvaltande organisationer t ex Stim.</p>

        <h4>Vad gäller om man vill kopiera och göra egna kopior av t ex bilder av materialet?</h4>
        <p>Förlaget följer praxis och gällande lagar. Det går alltid bra att tillfråga förlaget och i de flesta fall ger förlaget tillstånd.</p>

        <h4>Hur länge räcker ett Temapaket Kungaskogen?</h4>
        <p>Det räcker minst en termin som underlag för tematiskt arbete. Accessen gäller ett helt år.</p>

        <h4>Finns det material i Kungaskogen som man kan använda när man vill växla till annat tema?</h4>
        <p>Ja, det finns massor av material som knyter an till t ex matte, läsa, skriva, ABC mm</p>

        <h4>Hur många sånger finns det till Kungaskogen?</h4>
        <p>Fn finns det 33 sånger och många har redan blivit barnviseklassiker!</p>

        <h4>Finns sångerna på Spotify och YouTube?</h4>
        <p>Ja, Alla ljudinspelningar med dialoger, berättelser och sånger finns på Spotify och YouTube. I accessen använder vi en annan plattform för ljudinspelningarna så att t ex förskolor som inte har avtal med Spotify kan spela hela Kungaskogen. Med QR koderna så kan inspelningarna spelas precis som på en CD skiva (man kan pausa, välja spår mm).</p>

    
      </div>
    </div>
  </div>

);

export default fragor;
